export interface ICreatePagePreviewInput {
  positionId: string;
  body: string;
}

class CreateCommentInput {
  public readonly positionId: string;
  public readonly body: string;

  constructor({ positionId, body }: { positionId: string; body: string }) {
    this.positionId = positionId;
    this.body = body;
  }

  public toJSON = () => ({
    positionId: this.positionId,
    body: this.body,
  });

  public static fromJSON = (json: ICreatePagePreviewInput): CreateCommentInput => {
    const { positionId, body } = Object.assign({}, json);

    if (typeof positionId !== 'string') throw new Error('.positionId must be a string');
    if (typeof body !== 'string') throw new Error('.body must be a string');

    return new CreateCommentInput({
      positionId,
      body,
    });
  };
}

export default CreateCommentInput;
